<template>
  <v-dialog
    v-model="dialogTipo"
    @click:outside="$emit('update:dialogTipo', false)"
    @keydown.esc="$emit('update:dialogTipo', false)"
    width="50%"
    max-width="800"
  >
    <v-card>
      <v-card-title class="tocs_gray_1">{{
        $tc("global.tipo", 2)
      }}</v-card-title>
      <v-divider></v-divider>
      <div
        class="px-4 pt-4 d-block d-sm-flex align-center justify-space-between"
      >
        <v-text-field
          style="max-width: 200px"
          v-model="search"
          append-icon="mdi-magnify"
          :label="$tc('global.buscar')"
          clearable
          outlined
          solo
          flat
          dense
          hide-details
        >
        </v-text-field>
        <v-spacer class="d-none d-sm-flex"></v-spacer>

        <v-form
          @submit.prevent
          class="d-flex"
          ref="form"
          v-model="validForm"
          lazy-validation
        >
          <div class="d-flex mt-4 mt-sm-0">
            <v-text-field
              v-if="isAdding"
              v-model="tipo.descricao"
              :label="$tc('global.tipo')"
              dense
              hide-details
              class="pr-4"
              ref="tipoDescricao"
              :rules="formRules"
              required
            ></v-text-field>
            <v-btn
              v-if="!isAdding"
              :disabled="!PTipoAdicionar"
              color="button_1"
              class="white--text"
              @click="isAdding = !isAdding"
            >
              <v-icon left> mdi-plus</v-icon>
              {{ $tc("global.add") }}
            </v-btn>
            <v-btn
              v-if="isAdding"
              color="button_1"
              class="white--text"
              @click="createFornecedorTipo"
              :disabled="!validForm"
            >
              <v-icon left> mdi-check</v-icon>
              {{ $tc("global.salvar") }}
            </v-btn>
          </div>
        </v-form>
      </div>
      <v-card-text class="py-5">
        <v-data-table
          :headers="headers"
          :search="search.length >= 3 ? search : ''"
          :items="tipos"
          :items-per-page="10"
          disable-sort
          class="data-tables"
          :class="{ 'data-tables__row-click': PTipoEditar }"
        >
          <template v-slot:item.descricao="{ item, index }">
            <v-text-field
              v-if="editItem === index && isEditing"
              v-model="tipo_editar.descricao"
              dense
              hide-details
              ref="tipoDescricao"
              :rules="formRules"
              required
              class="mb-2"
            ></v-text-field>
            <div v-else>{{ item.descricao }}</div>
          </template>

          <template v-slot:item.status="{ item, index }">
            <div class="d-flex align-center justify-center">
              <v-switch
                v-if="isEditing && index === editItem"
                class="ma-0 pa-0"
                hide-details
                :false-value="0"
                :true-value="1"
                v-model="tipo_editar.status"
              ></v-switch>
              <v-switch
                v-else
                class="ma-0 pa-0"
                hide-details
                :false-value="0"
                :true-value="1"
                disabled
                v-model="item.status"
              ></v-switch>
            </div>
          </template>

          <template v-slot:item.editar="{ item, index }">
            <!-- Editar -->
            <v-btn
              v-if="!isEditing || editItem != index"
              small
              :disabled="!PTipoEditar"
              icon
              class=""
              @click="editRow(item, index)"
            >
              <v-icon>mdi-pencil-outline</v-icon>
            </v-btn>

            <div class="d-flex align-center justify-center">
              <!-- Salvar -->
              <v-btn
                v-if="isEditing && editItem === index"
                small
                icon
                class=""
                @click="salvarEdit(item)"
              >
                <v-icon>mdi-check</v-icon>
              </v-btn>

              <!-- Cancelar -->
              <v-btn
                v-if="isEditing && editItem === index"
                small
                icon
                class="ml-1"
                @click="closeEditing(item)"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  getFornecedoresTipos,
  postFornecedorTipo,
  putFornecedoresTipos,
} from "@/api/fornecedores/tipos_fornecedores.js";
import { inputRequired } from "@/helpers/utils.js";
import { mapGetters } from "vuex";
export default {
  props: {
    dialogTipo: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      tipos: [],
      isAdding: false,
      isEditing: false,
      validForm: true,
      formRules: [inputRequired],
      tipo: {},
      tipo_editar: {},
      search: "",
      editItem: null,
      itemOriginal: null,
    };
  },

  computed: {
    ...mapGetters("Componentes", ["getAccess"]),
    PTipoEditar() {
      return this.getAccess("FornecedorTipo", "editar");
    },
    PTipoAdicionar() {
      return this.getAccess("FornecedorTipo", "adicionar");
    },
    headers() {
      return [
        {
          text: this.$tc("global.tipo"),
          value: "descricao",
        },
        {
          text: "Status",
          sortable: false,
          width: "80px",
          align: "center",
          value: "status",
        },
        {
          text: "Editar",
          sortable: false,
          width: "80px",
          align: "center",
          value: "editar",
        },
      ];
    },
  },

  methods: {
    getFornecedoresTipos() {
      this.loading = true;
      getFornecedoresTipos()
        .then((response) => {
          this.tipos = response;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    createFornecedorTipo() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        postFornecedorTipo(this.tipo)
          .then(() => {
            this.getFornecedoresTipos();
            this.isAdding = false;
            this.tipo.descricao = null;
          })
          .catch((error) => {
            this.$toast.error("Categoria já existente!");
            this.$refs.tipoDescricao.reset();
            this.$refs.tipoDescricao.focus();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    closeEditing(item) {
      this.itemOriginal = { ...item };
      this.isEditing = false;
      this.editItem = null;
    },

    editRow(item, index) {
      this.itemOriginal = { ...item };
      this.tipo_editar = { ...item };
      this.isEditing = true;
      this.isAdding = false;
      this.editItem = index;
    },

    salvarEdit() {
      if (
        JSON.stringify(this.itemOriginal) === JSON.stringify(this.tipo_editar)
      ) {
        this.$toast.error("Por favor faça uma modificação antes de salvar");
        return;
      }
      if (
        this.tipo_editar.descricao === null ||
        this.tipo_editar.descricao === "" ||
        this.tipo_editar.descricao === undefined
      ) {
        this.$toast.error("Por favor preencha o campo de tipo!");
        return;
      }
      if (this.$refs.form.validate()) {
        this.loading = true;

        putFornecedoresTipos(this.tipo_editar.id, this.tipo_editar)
          .then(() => {
            this.loading = false;
            this.isEditing = false;
            this.editItem = null;
            this.getFornecedoresTipos();
          })
          .catch((error) => {
            this.$toast.error("Tipo já existente!");
          });
      }
    },
  },
  mounted() {
    this.getFornecedoresTipos();
  },
};
</script>

<style></style>
